module.exports = __webpack_public_path__ + "assets/images/news-header@3x-d5bd1c7f08dbfbae16afe7ed3734f981.jpg";